import { DateRangeCustomFilterEnum as e } from "../../types/date-range-filter-enum.js";
import { setDateWithTimezone as t } from "../../utils/date-utils.js";
//#region src/date-picker/date-range-picker/utils/set-custom-filter.ts
var n = (e, n) => {
	let r = t("", n);
	return r.setHours(23, 59, 59, 999), [t(e, n), r];
}, r = (e) => {
	let n = t("", e);
	n.setHours(23, 59, 59, 999);
	let r = t("", e);
	return r.setMonth(r.getMonth() - 3), r.setHours(0, 0, 0, 0), [r, n];
}, i = (t, r) => ({
	handler: () => n(t, r),
	slug: e.AllTime
}), a = (t) => ({
	handler: () => r(t),
	slug: e.Last3Months
});
//#endregion
export { i as getDefaultCustomFilter, a as getLast3MonthsCustomFilter };
